import { isGtmEnabled } from './client';

/**
 * Single choke point for every GTM dataLayer push: stays inert until consent allows GTM (off-GDPR or accepted on GDPR) and again after Reject/withdraw, so no events are queued pre-consent or once consent is withdrawn.
 */
export const pushToDataLayer = (data: Record<string, unknown>): void => {
  if (typeof window === 'undefined' || !isGtmEnabled()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

/**
 * Push a named event to the GTM dataLayer.
 */
export const gtmEvent = (eventName: string, eventProperties?: Record<string, unknown>) => {
  pushToDataLayer({ event: eventName, ...eventProperties });
};
